import * as React from 'react';
import * as vid from "./style.module.scss";
export const Vid = () => {
  return (
    <section className={vid.vid}>
      <div className="container">
        <h2>1000 иностранных слов за&nbsp;день&nbsp;—&nbsp;легко!</h2>
        <p>День рекордов в Advance</p>
        <div className={vid.video}>
          <div className={vid.bg}>
            <iframe src="https://www.youtube.com/embed/-1D1lES2aj8" allowFullScreen></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};
